<div class="mx-auto flex h-full min-h-0 flex-col">
  @if ((isShopLoading$ | async) === false && (shop$ | async); as shop) {
    @if (categoriesWithProducts$ | async; as products) {
      @if (products.length) {
        <div
          appScrollSpy
          [ids]="idsCategories"
          (activeSectionChange)="$event && changeTab($event)"
          class="flex h-full min-h-0 flex-col"
        >
          <app-kiosk-vertical-category-list-atom
            [items]="tabCategories"
            [activeItem]="tab"
            (categoryChange)="onCategoryClick($event)"
            [backgroundColor]="backgroundColor"
            [itemSelectedBackgroundColor]="itemSelectedBackgroundColor"
            [itemBackgroundColor]="itemBackgroundColor"
            [itemTextColor]="itemTextColor"
            [itemSelectedTextColor]="itemSelectedTextColor"
            [accentColor]="accentColor"
            [displayCategoryName]="displayCategoryName"
            [categoryImageRatio]="categoryImageRatio"
            [categoryCardPadding]="categoryCardPadding"
            [categoryCardGap]="categoryCardGap"
            [categoryCardBorderRadius]="categoryCardBorderRadius"
            [categoryCardsPosition]="categoryCardsPosition"
            [displayArrows]="displayArrows"
            [displayDots]="displayDots"
            [displaySelectedCategoryBorder]="displaySelectedCategoryBorder"
            [selectedCategoryBorderColor]="selectedCategoryBorderColor"
            [unselectedCategoryBorderColor]="unselectedCategoryBorderColor"
            [selectedCategoryBorderWidth]="selectedCategoryBorderWidth"
            [displaySelectedCategoryHalo]="displaySelectedCategoryHalo"
            [selectedCategoryHaloColor]="selectedCategoryHaloColor"
            [selectedCategoryHaloOpacity]="selectedCategoryHaloOpacity"
            [selectedCategoryShadowSpread]="selectedCategoryShadowSpread"
            [displaySelectedCategoryZoom]="displaySelectedCategoryZoom"
            [selectedCategoryZoomScale]="selectedCategoryZoomScale"
            [selectedItemId]="previewSelectedCategoryId"
            class="flex h-full min-h-0 flex-col"
          >
          </app-kiosk-vertical-category-list-atom>
        </div>
      }
    }
  } @else {
    <div class="flex h-full flex-col">
      <div class="flex h-full flex-row justify-start">
        <div
          class="text-primary flex h-full w-[20vw] min-w-[20vw] flex-col items-center justify-start gap-2.5"
        >
          <div
            class="flex w-full animate-pulse cursor-pointer justify-center rounded-t-lg bg-neutral-200 py-4.5 shadow-sm"
          >
            <i class="icon icon-chevron-down rotate-180 text-neutral-50"></i>
          </div>
          <div class="flex w-full flex-1 flex-col gap-2.5 overflow-hidden scrollbar-hide">
            @for (i of [].constructor(7); track $index) {
              <div
                class="flex min-h-44 w-full animate-pulse flex-col items-center gap-2.5 bg-neutral-200 py-2.5 text-center"
                [style.border-radius]="categoryCardBorderRadiusCss"
              ></div>
            }
          </div>
          <div
            class="flex w-full animate-pulse cursor-pointer justify-center rounded-b-lg bg-neutral-200 py-4.5 shadow-sm"
          >
            <i class="icon icon-chevron-down text-neutral-50"></i>
          </div>
        </div>
        <div class="flex h-full flex-col items-center justify-center gap-2.5 px-2">
          @for (i of [].constructor(7); track $index) {
            <div class="h-2.5 w-2.5 animate-pulse rounded-full bg-neutral-200 transition-all"></div>
          }
        </div>
      </div>
    </div>
  }
  @if (warningMessages?.length) {
    <div class="my-5 px-5 py-5">
      @for (message of warningMessages; track message) {
        <p class="rounded-sm bg-highlight-50 p-4 font-accent">
          {{ message }}
        </p>
      }
    </div>
  }
</div>
